export default {
    state: {
        all: [],
        filtered: [],
        selectedClient: []
    },
};